// @flow

import React, { Component } from 'react';
import _ from 'lodash';

import { Dropdown, Form } from 'semantic-grab-ui/src';

export const ALL_OPTION = { key: -1, text: 'ALL', value: -1 };

type onChangeFn = (event: any, data: any) => void

export default class CDropdown extends Component {
  props: Object;

  selectAllOnChange = (event: any, data: any) => {
    const newData = _.clone(data);
    newData.value = (newData.value === ALL_OPTION.value)
      ? undefined
      : newData.value;
    this.props.onChange(event, newData);
  }

  noDeleteOnChange = (event: any, data: any) => {
    const newValue = _.cloneDeep(data.value);
    _.map(data.options, (option) => {
      if (_.get(option, 'noDelete') && (_.indexOf(newValue, option.value) === -1)) {
        newValue.push(option.value);
      }
    });
    this.props.onChange(event, { ...data, value: newValue });
  }

  cleanDirtyData = (next: onChangeFn): onChangeFn => (event: any, data: any) => {
    const values = data.value;
    const isValid = (value: any): boolean => {
      for (const i in this.props.options) {
        if (this.props.options[i] && this.props.options[i].value === value) {
          return true;
        }
      }

      return false;
    };
    const newValues = values && _.filter(values, isValid);
    next(event, { ...data, value: newValues });
  };

  render() {
    const { required = false, label, selectAllOption, noDelete = false, clearDirtyData = false } = this.props;
    // clean added props before sending to Dropdown
    const dropdownProps = _.omit(_.clone(this.props), ['selectAllOption', 'noDelete', 'clearDirtyData']);

    if (selectAllOption) {
      dropdownProps.options = _.concat([ALL_OPTION], dropdownProps.options);
      dropdownProps.value = (_.isNil(dropdownProps.value) || dropdownProps.value === '')
        ? ALL_OPTION.value
        : dropdownProps.value;
      dropdownProps.onChange = this.selectAllOnChange;
    }

    if (noDelete) {
      dropdownProps.onChange = this.noDeleteOnChange;
    }

    if (clearDirtyData) {
      dropdownProps.onChange = this.cleanDirtyData(dropdownProps.onChange);
    }

    return (
      <Form.Field required={required}>
        {label && <label>{label}</label>}
        <Dropdown
          selection
          {...dropdownProps}
        />
      </Form.Field>);
  }
}
